import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faCalendarAlt, faDollarSign, faEdit, faHashtag, faPercentage, faTimes } from '@fortawesome/free-solid-svg-icons';
import DatePicker, { getDay } from 'react-datepicker';
import es from 'date-fns/locale/es'
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from 'react-datepicker';
import moment from 'moment/moment';
registerLocale('es', es);

class Editar extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }
    state = {
        load: '',
        fecha_ingreso: '',
        tiempo_transcurrido: '',
        datosCargados: false,
        radicado: '',
        infoPQR: [],
        tipoAsuntos: [],
        departamentosVisita: [],
        municipiosVisita: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state.infoPQR;
        state[e.target.name] = e.target.value;
        this.setState({ infoPQR: state });
    };
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const fecha_ingreso = document.getElementById('fecha_ingreso').value;
        const fecha_vencimiento = document.getElementById('fecha_vencimiento').value;
        const estado_pqr = document.getElementById('ESTADO_PQR').value;
        const id_departamento = document.getElementById('ID_COD_DPTO').value;
        const id_municipio = document.getElementById('ID_COD_MPIO').value;
        const barrio = document.getElementById('barrio').value;
        const tipo_persona = document.getElementById('TIPO_PERSONA').value;
        const identificacion = document.getElementById('identificacion').value;
        const nombres = document.getElementById('nombres').value;
        const apellidos = document.getElementById('apellidos').value;
        const id_tipo_asunto = document.getElementById('ID_TIPO_ASUNTO').value;
        const peticion = document.getElementById('PETICION').value;
        const requiere_visita = document.getElementById('REQUIERE_VISITA').value;
        const fecha_respuesta = document.getElementById('fecha_respuesta').value;
        const observaciones_respuesta = document.getElementById('observaciones_respuesta').value;
        var errores = [];
        if (!fecha_ingreso) { errores.push("error_fecha_ingreso"); }
        if (!fecha_vencimiento) { errores.push("error_fecha_vencimiento"); }
        if (!estado_pqr) { errores.push("error_estado_pqr"); }
        if (!id_departamento) { errores.push("error_id_departamento"); }
        if (!id_municipio) { errores.push("error_id_municipio"); }
        if (!barrio) { errores.push("error_barrio"); }
        if (!tipo_persona) { errores.push("error_tipo_persona"); }
        if (!identificacion) { errores.push("error_identificacion"); }
        if (!nombres) { errores.push("error_nombres"); }
        if (!apellidos) { errores.push("error_apellidos"); }
        if (!id_tipo_asunto) { errores.push("error_id_tipo_asunto"); }
        if (!peticion) { errores.push("error_peticion"); }
        if (!requiere_visita) { errores.push("error_requiere_visita"); }
        if (!fecha_respuesta) { errores.push("error_fecha_respuesta"); }
        if (!observaciones_respuesta) { errores.push("error_observaciones_respuesta"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        formData.append('ID_COD_DPTO', window.localStorage.getItem('id_cod_dpto'));
        formData.append('ID_COD_MPIO', window.localStorage.getItem('id_cod_mpio'));
        console.log(formData);
        Swal.showLoading();
        authAxios.post("pqr/editar", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                Swal.close();
                Swal.fire(
                    'P.Q.R.!',
                    datosRespuesta.data.msj,
                    'success'
                )
                this.props.history.push("/MasterPQR");
            })
            .catch(console.log)
    }
    handleChange = (date) => {
        const fecha_ingreso = moment(date);
        this.setState({ fecha_ingreso: fecha_ingreso });
        document.getElementById("fecha_ingreso").value = fecha_ingreso;
    }
    isWeekday = (date) => {
        const day = date.getDay();
        return day !== 0 && day !== 6;
    }
    cargarMunicipios() {
        var id_departamento = document.getElementById('ID_COD_DPTO').value;
        Swal.showLoading();
        authAxios.get("municipios_visitas/buscardepartamento/" + id_departamento)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, municipiosVisita: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    crearRadicado = () => {
        Swal.showLoading();
        var id_departamento = document.getElementById("ID_COD_DPTO").value;
        var id_municipio = document.getElementById("ID_COD_MPIO").value;
        var id_tipo_asunto = document.getElementById("ID_TIPO_ASUNTO").value;
        var fecha_ingreso = document.getElementById("fecha_ingreso").value.replaceAll("-", "");
        authAxios.get("pqr/generar_radicado/" + id_departamento + "/" + id_municipio + "/" + id_tipo_asunto)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, radicado: datosRespuesta.data.resultadoTipoAsunto.ABREVIATURA + datosRespuesta.data.resultadoMunicipio.ABREVIATURA + fecha_ingreso, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    calcularFecha = () => {
        Swal.showLoading();
        var fecha_ingreso = document.getElementById("fecha_ingreso").value;
        authAxios.get("pqr/calcular_fecha/" + fecha_ingreso)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, fecha_vencimiento: datosRespuesta.data, load: '' });
                document.getElementById("fecha_vencimiento").value = datosRespuesta.data;
                Swal.close();
            })
            .catch(console.log);
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("pqr/ver/" + this.props.match.params.id)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true,
                                infoPQR: datosRespuesta.data.resultado,
                                radicado: datosRespuesta.data.resultado.RADICADO,
                                load: '' });
                var id_departamento = datosRespuesta.data.resultado.ID_COD_DPTO;
                var id_municipio = datosRespuesta.data.resultado.ID_COD_MPIO;
                document.getElementById("ID_COD_DPTO").value = id_departamento;
                document.getElementById("ID_COD_MPIO").value = id_municipio;
                const fecha_ingreso = moment(datosRespuesta.data.resultado.FECHA_INGRESO);
                const tiempo_transcurrido = datosRespuesta.data.tiempo_transcurrido + " días";
                this.setState({ fecha_ingreso: fecha_ingreso, tiempo_transcurrido: tiempo_transcurrido });
                document.getElementById("fecha_ingreso").value = fecha_ingreso;
            })
            .catch(console.log);
        authAxios.get("departamentos_visitas/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, departamentosVisita: datosRespuesta.data.data, load: '' });
                this.cargarMunicipios();
            })
            .catch(console.log);
        authAxios.get("pqr/tipo_asuntos")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, tipoAsuntos: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }

    render() {
        const { load, fecha_ingreso, tiempo_transcurrido, radicado, infoPQR, tipoAsuntos, departamentosVisita, municipiosVisita } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>EDITAR P.Q.R.</b>)}
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos} id="form">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-2">
                                                    <input type="hidden" name="id_pqr" value={this.props.match.params.id} />
                                                    <input type="hidden" name="id_usuario" id="id_usuario" value={window.localStorage.getItem('idusuario')} />
                                                    <label htmlFor="fecha_ingreso">Fecha Ingreso</label>
                                                    {/* <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_ingreso" id="fecha_ingreso" defaultValue={infoPQR.FECHA_INGRESO}
                                                            className={((this.verificarError("error_fecha_ingreso")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="FECHA INGRESO" aria-describedby="helpId"
                                                            onChange={this.cambioValor} />
                                                    </div> */}
                                                    <DatePicker
                                                        className={((this.verificarError("error_fecha_ingreso")) ? "is-invalid" : "") + " form-control form-control-sm"}
                                                        dateFormat="yyyy-MM-dd"
                                                        selected={Date.parse(fecha_ingreso)}
                                                        defaultValue={fecha_ingreso}
                                                        id="fecha_ingreso"
                                                        name="fecha_ingreso"
                                                        locale="es"
                                                        aria-describedby="helpId"
                                                        placeholderText="DD/MM/YYYY"
                                                        filterDate={this.isWeekday}
                                                        excludeDates={[ 1673240400000, 1679288400000, 1680757200000, 1680843600000, 1682917200000, 1684731600000,
                                                                        1686546000000, 1687150800000, 1688360400000, 1689829200000, 1691384400000, 1692594000000,
                                                                        1697432400000, 1699246800000, 1699851600000, 1702011600000, 1703480400000,
                                                                        1704085200000, 1704690000000, 1711342800000, 1711602000000, 1711688400000, 1714539600000,
                                                                        1715576400000, 1717390800000, 1717995600000, 1719810000000, 1721451600000, 1723006800000,
                                                                        1724043600000, 1728882000000, 1730696400000, 1731301200000, 1735102800000, 1735707600000 ]}
                                                        onKeyDown={(e) => {
                                                            e.preventDefault();
                                                        }}
                                                        onChange={(e) => {
                                                            this.handleChange(e);
                                                            this.calcularFecha(e);
                                                        }}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Fecha Ingreso</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="fecha_vencimiento">Fecha Vencimiento</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_vencimiento" id="fecha_vencimiento" defaultValue={infoPQR.FECHA_VENCIMIENTO}
                                                            className={((this.verificarError("error_fecha_vencimiento")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="FECHA VENCIMIENTO" aria-describedby="helpId"
                                                            onChange={this.cambioValor} readOnly />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Fecha Entrega</small>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="tiempo_transcurrido">Días Transcurridos</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="tiempo_transcurrido" id="tiempo_transcurrido" defaultValue={tiempo_transcurrido}
                                                            className={((this.verificarError("error_tiempo_transcurrido")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="TIEMPO TRANSCURRIDO" aria-describedby="helpId"
                                                            onChange={this.cambioValor} readOnly />
                                                </div>
                                                <div className='col-md-3'></div>
                                                <div className='col-md-3'>
                                                    <label htmlFor="ESTADO_PQR">Estado P.Q.R.</label>
                                                    <select name="ESTADO_PQR"
                                                        id="ESTADO_PQR"
                                                        value={infoPQR.ESTADO_PQR}
                                                        options={infoPQR.ESTADO_PQR}
                                                        className={((this.verificarError("error_estado_pqr")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Estado P.Q.R.</option>
                                                        <option value="1">RECIBIDO</option>
                                                        <option value="2">RESUELTO</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Estado P.Q.R.</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN MUNICIPIO / CONTRIBUYENTE</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="ID_COD_DPTO">Departamento</label>
                                                    <select name="ID_COD_DPTO"
                                                        id="ID_COD_DPTO"
                                                        value={infoPQR.ID_COD_DPTO}
                                                        options={infoPQR.ID_COD_DPTO}
                                                        onChange={e => {
                                                            this.cargarMunicipios(e);
                                                            this.cambioValor(e)
                                                        }}
                                                        className={((this.verificarError("error_id_departamento")) ? "is-invalid" : "") + " form-select form-select-sm"} disabled>
                                                        <option value="">Seleccione el Departamento</option>
                                                        {
                                                            departamentosVisita.map((itemDepartamentosVisita) => (
                                                                <option key={itemDepartamentosVisita.ID_TABLA} value={itemDepartamentosVisita.ID_DEPARTAMENTO}>{itemDepartamentosVisita.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="ID_COD_MPIO">Municipio</label>
                                                    <select name="ID_COD_MPIO"
                                                        id="ID_COD_MPIO"
                                                        value={infoPQR.ID_COD_MPIO}
                                                        options={infoPQR.ID_COD_MPIO}
                                                        className={((this.verificarError("error_id_municipio")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor} disabled>
                                                        <option value="">Seleccione el Municipio</option>
                                                        {
                                                            municipiosVisita.map((itemMunicipiosVisita) => (
                                                                <option key={itemMunicipiosVisita.ID_TABLA} value={itemMunicipiosVisita.ID_MUNICIPIO}>{itemMunicipiosVisita.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Municipio</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="barrio">Barrio</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="barrio" id="barrio" defaultValue={infoPQR.BARRIO}
                                                        className={((this.verificarError("error_barrio")) ? "is-invalid" : "") + " form-control form-control-sm"}  placeholder="BARRIO" aria-describedby="helpId"
                                                        onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Barrio</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-2'>
                                                    <label htmlFor="TIPO_PERSONA">Tipo Persona</label>
                                                    <select name="TIPO_PERSONA"
                                                        id="TIPO_PERSONA"
                                                        value={infoPQR.TIPO_PERSONA}
                                                        options={infoPQR.TIPO_PERSONA}
                                                        className={((this.verificarError("error_tipo_persona")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Tipo Cliente</option>
                                                        <option value="1">NATURAL</option>
                                                        <option value="2">JURIDICA</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Tipo Persona</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="identificacion">Identificación</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="identificacion" id="identificacion" defaultValue={infoPQR.IDENTIFICACION}
                                                            className={((this.verificarError("error_identificacion")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="IDENTIFICACIÓN" aria-describedby="helpId"
                                                            onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite la Identificación</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="nombres">Nombres</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="nombres" id="nombres" defaultValue={infoPQR.NOMBRES}
                                                        className={((this.verificarError("error_nombres")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="NOMBRES" aria-describedby="helpId"
                                                        onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite los Nombres</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="apellidos">Apellidos</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="apellidos" id="apellidos" defaultValue={infoPQR.APELLIDOS}
                                                        className={((this.verificarError("error_apellidos")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="APELLIDOS" aria-describedby="helpId"
                                                        onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite los Apellidos</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="cargo">Cargo</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="cargo" id="cargo" defaultValue={infoPQR.CARGO_USUARIO}
                                                        className={((this.verificarError("error_cargo")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="CARGO" aria-describedby="helpId"
                                                        onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Cargo</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="direccion">Dirección</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="direccion" id="direccion" defaultValue={infoPQR.DIRECCION}
                                                        className={((this.verificarError("error_direccion")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="DIRECCIÓN" aria-describedby="helpId"
                                                        onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite la Dirección</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="telefono">Teléfono</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="telefono" id="telefono" defaultValue={infoPQR.TELEFONO}
                                                        className={((this.verificarError("error_telefono")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="TELEFONO" aria-describedby="helpId"
                                                        onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Teléfono</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="correo_electronico">Correo Electrónico</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faAt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="correo_electronico" id="correo_electronico" defaultValue={infoPQR.CORREO_ELECTRONICO}
                                                            className={((this.verificarError("error_correo_electronico")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="CORREO ELECTRÓNICO" aria-describedby="helpId"
                                                            onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Correo Electrónico</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN P.Q.R.</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className="row g-3">
                                                <div className="col-md-3">
                                                    <label htmlFor="radicado">Radicado</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input type='hidden' name='radicado_general' id='radicado_general' defaultValue={infoPQR.RADICADO} />
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="radicado" id="radicado" defaultValue={radicado} 
                                                            className={((this.verificarError("error_radicado")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="RADICADO" aria-describedby="helpId"
                                                            onChange={this.cambioValor} readOnly />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Radicado</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className="row g-3">
                                                <div className='col-md-6'>
                                                    <label htmlFor="ID_TIPO_ASUNTO">Tipo Asunto</label>
                                                    <select name="ID_TIPO_ASUNTO"
                                                        id="ID_TIPO_ASUNTO"
                                                        value={infoPQR.ID_TIPO_ASUNTO}
                                                        options={infoPQR.ID_TIPO_ASUNTO}
                                                        className={((this.verificarError("error_id_tipo_asunto")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={(e) => {
                                                            this.crearRadicado(e);
                                                            this.cambioValor(e);
                                                        }}>
                                                        <option value="">Seleccione el Tipo Asunto</option>
                                                        {
                                                            tipoAsuntos.map((itemTipoAsunto) => (
                                                                <option key={itemTipoAsunto.ID_TIPO_ASUNTO} value={itemTipoAsunto.ID_TIPO_ASUNTO}>{itemTipoAsunto.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Tipo Asunto</small>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="PETICION">Petición</label>
                                                    <select name="PETICION"
                                                        id="PETICION"
                                                        value={infoPQR.PETICION}
                                                        options={infoPQR.PETICION}
                                                        className={((this.verificarError("error_peticion")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione la Petición</option>
                                                        <option value="1">ESCRITA</option>
                                                        <option value="2">VERBAL</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Petición</small>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="REQUIERE_VISITA">Requiere Visita</label>
                                                    <select name="REQUIERE_VISITA"
                                                        id="REQUIERE_VISITA"
                                                        value={infoPQR.REQUIERE_VISITA}
                                                        options={infoPQR.REQUIERE_VISITA}
                                                        className={((this.verificarError("error_requiere_visita")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione si Requiere Visita</option>
                                                        <option value="1">SI</option>
                                                        <option value="2">NO</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione si Requiere Visita</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-12">
                                                    <label htmlFor="observaciones">Observaciones</label>
                                                    <textarea style={{ resize: 'none', textTransform: 'uppercase' }} id="observaciones" name="observaciones" rows='3' defaultValue={infoPQR.OBSERVACIONES}
                                                        className='form-control form-control-sm' onChange={this.cambioValor} aria-describedby="helpId"></textarea>
                                                    <small id="helpId" className="invalid-feedback">Digite las Observaciones</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN RESPUESTA P.Q.R.</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="fecha_respuesta">Fecha Respuesta</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_respuesta" id="fecha_respuesta" defaultValue={infoPQR.FECHA_RESPUESTA}
                                                            className={((this.verificarError("error_fecha_respuesta")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="FECHA RESPUESTA" aria-describedby="helpId"
                                                            onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Fecha Respuesta</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-12">
                                                    <label htmlFor="observaciones_respuesta">Observaciones Respuesta</label>
                                                    <textarea style={{ resize: 'none', textTransform: 'uppercase' }} id="observaciones_respuesta" name="observaciones_respuesta" rows='3' defaultValue={infoPQR.OBSERVACIONES_RESPUESTA}
                                                        className={((this.verificarError("error_observaciones_respuesta")) ? "is-invalid" : "") + " form-control form-control-sm"} onChange={this.cambioValor} aria-describedby="helpId"></textarea>
                                                    <small id="helpId" className="invalid-feedback">Digite las Observaciones Respuesta</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar P.Q.R.</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterPQR"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;